import React from 'react';

const FilterBar = ({ filters, onFilterChange, onReset }) => {
    return (
        <div style={styles.filterContainer}>
            <div style={styles.headerRow}>
                <h3 style={styles.title}>Filtres</h3>
                <button 
                    onClick={onReset} 
                    style={styles.resetBtn}
                    onMouseOver={(e) => {
                        e.currentTarget.style.backgroundColor = 'var(--primary-color)';
                        e.currentTarget.style.color = 'var(--white)';
                    }}
                    onMouseOut={(e) => {
                        e.currentTarget.style.backgroundColor = 'transparent';
                        e.currentTarget.style.color = 'var(--primary-color)';
                    }}
                >
                    🔄 Réinitialiser
                </button>
            </div>

            <div style={styles.filterGrid}>
                {filters.map((filter, idx) => {
                    switch (filter.type) {
                        case 'select':
                            return (
                                <div key={idx} style={styles.filterItem}>
                                    <label style={styles.filterLabel}>{filter.label}</label>
                                    <select 
                                        value={filter.value} 
                                        onChange={(e) => onFilterChange(filter.name, e.target.value)}
                                        style={styles.filterInput}
                                    >
                                        <option value="">Tous</option>
                                        {filter.options.map((opt, i) => (
                                            <option key={i} value={opt.value}>{opt.label}</option>
                                        ))}
                                    </select>
                                </div>
                            );
                        
                        case 'date':
                            return (
                                <div key={idx} style={styles.filterItem}>
                                    <label style={styles.filterLabel}>{filter.label}</label>
                                    <input 
                                        type="date"
                                        value={filter.value}
                                        onChange={(e) => onFilterChange(filter.name, e.target.value)}
                                        style={styles.filterInput}
                                    />
                                </div>
                            );
                        
                        case 'number':
                            return (
                                <div key={idx} style={styles.filterItem}>
                                    <label style={styles.filterLabel}>{filter.label}</label>
                                    <div style={styles.numberRange}>
                                        <input 
                                            type="number"
                                            placeholder="Min"
                                            value={filter.min || ''}
                                            onChange={(e) => onFilterChange(filter.name, { ...filter, min: e.target.value })}
                                            style={{...styles.filterInput, ...styles.halfInput}}
                                        />
                                        <span style={styles.rangeSeparator}>-</span>
                                        <input 
                                            type="number"
                                            placeholder="Max"
                                            value={filter.max || ''}
                                            onChange={(e) => onFilterChange(filter.name, { ...filter, max: e.target.value })}
                                            style={{...styles.filterInput, ...styles.halfInput}}
                                        />
                                    </div>
                                </div>
                            );
                        
                        default:
                            return null;
                    }
                })}
            </div>
        </div>
    );
};

const styles = {
    filterContainer: {
        backgroundColor: 'var(--white)',
        padding: '24px', // Un peu plus d'espace pour aérer
        borderRadius: 'var(--border-radius)',
        marginBottom: '24px',
        boxShadow: 'var(--shadow)',
        border: '1px solid #e9ecef', // Bordure très légère pour délimiter
    },
    headerRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '20px',
        borderBottom: '1px solid #eee',
        paddingBottom: '15px',
    },
    title: {
        margin: 0,
        fontSize: '1.1rem',
        color: 'var(--primary-color)',
        fontWeight: '600',
    },
    filterGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
        gap: '20px',
    },
    filterItem: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
    },
    filterLabel: {
        fontSize: '0.9rem',
        fontWeight: '500',
        color: 'var(--text-muted)', // Gris foncé au lieu de blanc
        marginBottom: '2px',
    },
    filterInput: {
        padding: '10px 12px',
        borderRadius: 'var(--border-radius)',
        border: '1px solid #ced4da', // Bordure standard gris clair
        fontSize: '0.95rem',
        backgroundColor: 'var(--secondary-bg)', // Fond très légèrement grisé
        color: 'var(--text-color)',
        outline: 'none',
        transition: 'border-color 0.2s',
        width: '100%',
        boxSizing: 'border-box',
    },
    numberRange: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
    },
    halfInput: {
        width: '100%', // Prend la place dispo dans le flex
    },
    rangeSeparator: {
        color: 'var(--text-muted)',
        fontWeight: 'bold',
    },
    resetBtn: {
        backgroundColor: 'transparent',
        color: 'var(--primary-color)',
        border: '1px solid var(--primary-color)',
        padding: '8px 16px',
        borderRadius: 'var(--border-radius)',
        cursor: 'pointer',
        fontSize: '0.9rem',
        fontWeight: '500',
        transition: 'all 0.2s ease',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
    },
};

export default FilterBar;